import * as React from "react";
import { useMemo } from "react";
import { Alert } from "components/bootstrap";
import { DocumentationLink } from "components/support";
import DocsHelper from "util/DocsHelper";
import DataLakeWidgetConfig from "data-lake/logic/DataLakeWidgetConfig";
import PreviewLayoutContext from "../../../contexts/PreviewLayoutContext";
const WidgetEditInfo = () => /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, "The field select contains options for fields which exist as columns in the data lake. It is possible to type in and add any custom field name, by clicking on the ", /* @__PURE__ */ React.createElement("i", null, 'Create "custom_field"'), " option. See", " ", /* @__PURE__ */ React.createElement(DocumentationLink, { page: DocsHelper.PAGES.DATA_LAKE, text: "documentation" }), ".");
const PreviewLayoutProvider = ({ children }) => {
  const contextValue = useMemo(
    () => ({
      widgetEdit: {
        formInfo: /* @__PURE__ */ React.createElement(WidgetEditInfo, null),
        showFieldSelect: true,
        fieldsCreationAllowed: true
      },
      defaultFields: DataLakeWidgetConfig.defaultFields
    }),
    []
  );
  return /* @__PURE__ */ React.createElement(PreviewLayoutContext.Provider, { value: contextValue }, children);
};
export default PreviewLayoutProvider;
